import DirectoryItem from "../Directory-item/directory-item.component";
import './directory.styles.scss'

const categories = [
    {
        "id": 1,
        "title": "hats",
        "imageUrl": "https://raw.githubusercontent.com/varunshah3129/crown_king_proj_images/main/images/hats.png",
        "route": "shop/hats"
    },
    {
        "id": 2,
        "title": "jackets",
        "imageUrl": "https://raw.githubusercontent.com/varunshah3129/crown_king_proj_images/main/images/jackets.png",
        "route": "shop/jackets"
    },
    {
        "id": 3,
        "title": "sneakers",
        "imageUrl": "https://raw.githubusercontent.com/varunshah3129/crown_king_proj_images/main/images/sneakers.png",
        "route": "shop/sneakers"
    },
    {
        "id": 4,
        "title": "womens",
        "imageUrl": "https://raw.githubusercontent.com/varunshah3129/crown_king_proj_images/main/images/womens.png",
        "route": "shop/womens"
    },
    {
        "id": 5,
        "title": "mens",
        "imageUrl": "https://raw.githubusercontent.com/varunshah3129/crown_king_proj_images/main/images/men.png",
        "route": "shop/mens"
    }
]

const Directory = () => {
    return (
        <div className="directory-container">
            {categories.map((category) => (
                <DirectoryItem key={category.id} category={category}/>
            ))}
        </div>
    )
}

export default Directory
